import {
	getEmptyElement,
	isEmptyRowContent,
	isPlaceholderRow,
} from "containers/Form/SimplifiedBuilder/Internal/ModelFunctions";

export const doMoveElement = (layoutDefinition, dragRow, dragCol, hoverRow, newColPosition) => {
	const newLayoutDefinition = [ ...layoutDefinition ];
	const dragComponent = newLayoutDefinition[dragRow].cols[dragCol];
	if (newLayoutDefinition[dragRow].cols.length === 1 && !isPlaceholderRow(newLayoutDefinition, dragRow - 1)) {
		newLayoutDefinition[dragRow].cols.splice(dragCol, 1, getEmptyElement().cols[0]);
	} else {
		newLayoutDefinition[dragRow].cols.splice(dragCol, 1);
	}
	newLayoutDefinition[hoverRow].cols.splice(newColPosition, 0, dragComponent);

	return newLayoutDefinition;
};

export const doDeleteElement = (layoutDefinition, elementToDelete) => {
	const newLayoutDefinition = [ ...layoutDefinition ];
	const { row, column } = elementToDelete;
	newLayoutDefinition[row].cols.splice(column, 1);
	if (isEmptyRowContent(newLayoutDefinition[row])) {
		newLayoutDefinition.splice(row, 1);
	}

	return newLayoutDefinition;
};
